import { List, ListItemText, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { RestrictedItem } from '../../../../lib/cart/types'

export interface RestrictedItemsListProps {
  className?: string
  restrictedItems: RestrictedItem[]
}

const RestrictedItems = styled(List)`
  margin-bottom: 15px;
`

export const RestrictedItemsList: React.FC<RestrictedItemsListProps> = ({
  className,
  children,
  restrictedItems = [],
}) => {
  return (
    <RestrictedItems className={className}>
      {restrictedItems.map((restrictedItem) => (
        <ListItemText key={`restricted-item-${restrictedItem.id}`}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            &bull; {restrictedItem.name}
          </Typography>
        </ListItemText>
      ))}
      {children}
    </RestrictedItems>
  )
}
